import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {environment} from './environments/environment';
import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  includeBearerTokenInterceptor,
  provideKeycloak,
  ProvideKeycloakOptions
} from 'keycloak-angular';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {httpHeaderInterceptor} from './app/core/interceptors/http-header.interceptor';
import {httpParameterCleanerInterceptor} from './app/core/interceptors/http-parameter-cleaner.interceptor';
import {bootstrapApplication} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideTranslateService, RootTranslateServiceConfig} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppComponent} from './app/app.component';
import {ADMIN_APP_ID} from './app/core/models/admin.constants';
import {PreloadAllModules, provideRouter, withPreloading} from '@angular/router';
import {APP_ROUTES} from './app/app-routing.module';
import {ConsoleInstrumentation, ErrorsInstrumentation, initializeFaro, LogLevel} from '@grafana/faro-web-sdk';
import packageInfo from '../package.json';


if (environment.production) {
  enableProdMode();
}


const tokenInterceptor = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^(${environment.baseUrl})(\\/.*)?$`, 'i'),
  bearerPrefix: 'Bearer'
});


const keycloakOptions: ProvideKeycloakOptions = {
  config: environment.keycloak,
  initOptions: {
    onLoad: 'login-required',
    checkLoginIframe: false,
    responseMode: 'fragment',
    flow: 'standard',
  },
};

const translateConfig: RootTranslateServiceConfig = {
  fallbackLang: 'en-US',
  loader: provideTranslateHttpLoader({
    prefix: `${environment.babelApiUrl}/translations/${ADMIN_APP_ID}/lang/`,
    suffix: '',
    enforceLoading: false,
    useHttpBackend: true
  })
};


if (environment.faroUrl) {
  initializeFaro({
    url: environment.faroUrl,
    app: {
      name: 'easytrack-admin',
      version: packageInfo.version,
      environment: environment.environment
    },
    instrumentations: [
      new ErrorsInstrumentation(),
      new ConsoleInstrumentation()
    ],
    consoleInstrumentation: {
      disabledLevels: [LogLevel.DEBUG, LogLevel.TRACE, LogLevel.INFO, LogLevel.LOG, LogLevel.WARN],
      consoleErrorAsLog: true
    }
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(), provideTranslateService(translateConfig),
    provideKeycloak(keycloakOptions),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [tokenInterceptor]
    },
    provideHttpClient(
      withInterceptors([httpHeaderInterceptor, httpParameterCleanerInterceptor, includeBearerTokenInterceptor])
    ),
    provideRouter(APP_ROUTES, withPreloading(PreloadAllModules)),
    provideAnimations(),
  ]
})
  .catch(err => console.error(err));
